import React from 'react'
import './experience.css'
import {
  SiPython,
  SiMicrosoftsqlserver,
  SiPowerbi,
  SiTableau,
  SiReact,
  SiNodedotjs,
  SiDjango,
  SiTailwindcss,
  SiBootstrap,
  SiAmazonaws,
  SiPostgresql,
  SiMysql,
  SiHtml5,
  SiCss3,
  SiJavascript,
  SiElasticsearch,
} from 'react-icons/si'

const SKILL_CATEGORIES = [
  {
    title: 'Data & BI',
    skills: [
      { Icon: SiPowerbi, label: 'Power BI' },
      { Icon: SiTableau, label: 'Tableau' },
      { Icon: SiMicrosoftsqlserver, label: 'SQL Server' },
    ],
  },
  {
    title: 'Languages',
    skills: [
      { Icon: SiPython, label: 'Python' },
      { Icon: SiJavascript, label: 'JavaScript' },
      { Icon: SiHtml5, label: 'HTML' },
      { Icon: SiCss3, label: 'CSS' },
    ],
  },
  {
    title: 'Web & frameworks',
    skills: [
      { Icon: SiReact, label: 'React' },
      { Icon: SiNodedotjs, label: 'Node.js' },
      { Icon: SiDjango, label: 'Django' },
      { Icon: SiTailwindcss, label: 'Tailwind' },
      { Icon: SiBootstrap, label: 'Bootstrap' },
    ],
  },
  {
    title: 'Cloud & data',
    skills: [
      { Icon: SiAmazonaws, label: 'AWS' },
      { Icon: SiPostgresql, label: 'PostgreSQL' },
      { Icon: SiMysql, label: 'MySQL' },
      { Icon: SiElasticsearch, label: 'Elasticsearch' },
    ],
  },
]

const Experience = () => {
  return (
    <section id='experience'>
      <h5>What Skills I Have</h5>
      <h2>My Experience</h2>
      <p className='experience_intro'>
        Tools and platforms I use across data, engineering, and delivery — grouped by focus area.
      </p>

      <div className='container experience_skills'>
        {SKILL_CATEGORIES.map((category) => (
          <div className='skill-category' key={category.title}>
            <h3 className='skill-category__title'>{category.title}</h3>
            <div className='skill-grid'>
              {category.skills.map(({ Icon, label }) => (
                <div className='skill-tile' key={label}>
                  <span className='skill-tile__icon' aria-hidden='true'>
                    <Icon />
                  </span>
                  <span className='skill-tile__label'>{label}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default Experience
